import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router";

import {
  CashIcon,
  CreditcardIcon,
  GiftCardIcon,
  StoreCreditIcon,
} from "../../../../assets/icons/iconsProvider";
import {
  buttonNameConstants,
  categoryDropdownConstants,
  EMPTY_STRING,
  routesPathConstants,
  SALE_TRANSACTION_ACTIVITY_TYPES,
  toastMessages,
  toastType,
  toggleSwitchButtonConstants,
  transactionConstants,
} from "../../../../constants";
import {
  deviceActions,
  outletActions,
  systemActions,
  transactionActions,
} from "../../../../redux/actions";
import {
  handleOpenCashDrawer,
  prepareReceiptForPrinter,
} from "../../../../shared/Printers/ReceiptPrinters/prepareReceiptForPrinter";
import { printReceiptData } from "../../../../shared/Printers/ReceiptPrinters/printReceipt";
import {
  buildTransactionPayload,
  checkIsOutletOpen,
  convertToFixedPrecision,
  createCompanyDynamicUrl,
  customToast,
  getAdjustedPaymentAmount,
  getCountOfTotalItems,
  getCurrentMacAddress,
  getGiftCardDetailsObject,
  getOutletRelationObjectForSaleTradePayload,
  getReceiptPrintDate,
  getSessionIdForSaleTradePayload,
  getShortestSku,
  getSumOfPaymentHistory,
  handleCalculateIndividualItemPriceStats,
  handleTransactionData,
  handleZeroOnBlur,
  isTransactionInProgress,
  parseJsonObject,
  parseToDecimalNumber,
  parseToNumber,
  parseToThousandSeperatorDecimalNumber,
  recalculatePreTaxTotals,
} from "../../../../shared/utility";
import {
  PRODUCT_TYPES_ENUMS,
  STORE_CARD_PAYMENT_TYPE_ENUMS,
} from "../../../../system/globalEnums";
import AddNewCustomerModal from "../AddNewCustomer/AddNewCustomerModal";
import CardPayment from "./CardPayment";
import CashPayment from "./CashPayment";
import GiftCardPayment from "./GiftCardPayment";
import OtherPayment from "./OtherPayment";
import PaymentComplete from "./PaymentComplete";
import {
  Button,
  Topbar,
  CustomerDropdown,
  SelectedCustomerCard,
  TransactionPaymentHistory,
  ProductNameOnPaymentScreen,
} from "../../../../shared/components";

const NewTransactionPayment = (props) => {
  const {
    user,
    outlet,
    printer,
    customer,
    transaction,
    spinnerArray,
    currentStore,
    storeDevices,
    sendEmailOrSMS,
    getStoreDevices,
    activateSpinner,
    giftCardDetails,
    deactivateSpinner,
    handleNewParkSale,
    newSaleTransaction,
    isAddCustomerModal,
    getGiftCardDetails,
    setTransactionData,
    emptyGiftCardDetails,
    cancelCardTransaction,
    getOutletByMacAddress,
    toggleAddCustomerModal,
  } = props;
  const navigate = useNavigate();
  const { transactionData } = transaction;

  //-------isApplyStoreCreditPaymentsasPre-Tax
  const isApplyStoreCreditPaymentsAsPreTax =
    currentStore?.[
      toggleSwitchButtonConstants.APPLY_STORE_CREDIT_PAYMENTS_AS_PRE_TAX
    ] || false;

  //-------outlet reducer
  const { currentOutlet, currentSessionId } = outlet;

  //-------useRef
  let cartItemsCount = useRef(transactionData?.inventory?.length ?? 0);
  const [changeOwed, setChangeOwed] = useState(0);
  const [amountTendered, setAmountTendered] = useState(0);
  const [addCustomerModal, setAddCustomerModal] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [customerToEdit, setCustomerToEdit] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState(
    transactionData?.customer?.id && transactionData?.customer
  );
  const [selectedCustomerFlag, setSelectedCustomerFlag] = useState(false);
  //handle amount tendered change
  const handleAmountTenderedChange = (e) => {
    const maxLength = 15;
    const amount = e;
    let owedAmount = 0;
    if (amount.length >= maxLength) {
      return;
    } else if (Number(amount) >= Number(transactionData?.currentAmountToPay)) {
      setAmountTendered(amount);
      owedAmount = parseToNumber(amount) - transactionData?.currentAmountToPay;
      setChangeOwed(parseToNumber(owedAmount));
    } else {
      setAmountTendered(amount);
      setChangeOwed(0);
    }
  };
  //-------Customer reducer
  const { allCustomers } = customer; //------printer reducer
  const { defaultReceiptPrinter } = printer;

  const handleFixedAmountButtonClick = (amount) => {
    let owedAmount = 0;
    const tenderedAmount = Number(amountTendered) + amount;

    setAmountTendered(tenderedAmount.toFixed(2));
    if (tenderedAmount > transactionData?.currentAmountToPay) {
      owedAmount =
        Number(tenderedAmount).toFixed(2) -
        Number(transactionData?.currentAmountToPay).toFixed(2);
      setChangeOwed(parseToNumber(owedAmount));
    } else {
      setChangeOwed(0);
    }
  };

  //------update Transaction Data
  const updateTransactionData = (data, activityName) => {
    handleTransactionData(
      data,
      user,
      currentStore,
      activityName,
      transactionData,
      setTransactionData
    );
  };

  //------ handle customer edit
  const handleCustomerEditClick = () => {
    const customer = allCustomers?.find(
      (customer) => customer.id === transactionData?.customer?.id
    );
    if (customer?.id) {
      setCustomerToEdit(customer);
      toggleAddCustomerModal(true);
    }
  };

  const handleReturnPayment = async (history) => {
    handlePaymentMethod(EMPTY_STRING); //as soon as user clicks x to undo transaction we will set the default left side payment screen with all payment options
    if (
      checkIsOutletOpen(
        navigate,
        routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION,
        currentStore,
        getCurrentMacAddress,
        getOutletByMacAddress
      )
    ) {
      handleParkSaleClick();
      return;
    }

    //------if paymenttype is gift card
    const giftCard =
      history.paymentType === transactionConstants.GIFT_CARD
        ? {
            giftCardName: history.giftCardName,
            giftCardChargeAmount: history.giftCardChargeAmount,
            giftCardBarcode: history.giftCardBarcode,
            giftCardTotalBalance: history.giftCardBalance,
            remainingBalance: history.remainingBalance,
          }
        : {};

    const cashTenderedAmount =
      history?.paymentType === transactionConstants.CASH
        ? history.cashTenderedAmount
        : 0;

    const cashChangeOwed =
      history?.paymentType === transactionConstants.CASH
        ? history.cashChangeOwed
        : 0;

    const otherAmountTendered =
      history?.paymentType === transactionConstants.OTHER
        ? history.otherAmountTendered
        : 0;

    const activeCardPaymentType =
      history?.paymentType === transactionConstants.CREDIT_CARD
        ? currentStore.activeCardPaymentType
        : STORE_CARD_PAYMENT_TYPE_ENUMS.NULL;

    if (
      history.paymentType === transactionConstants.CREDIT_CARD &&
      (history.activeCardPaymentType ===
        STORE_CARD_PAYMENT_TYPE_ENUMS.VERIFONE ||
        history.activeCardPaymentType ===
          STORE_CARD_PAYMENT_TYPE_ENUMS.PAYRILLIUM)
    ) {
      updateTransactionData(
        {
          ...transactionData,
          paymentDevice: history.poiId,
          paymentMethod: transactionConstants.CREDIT_CARD_PAYMENT,
        },
        SALE_TRANSACTION_ACTIVITY_TYPES.RETURN_PAYMENT
      );
    }

    const dataToSend = {
      creditUsed: transactionData?.creditUsed,
      id: transactionData?.id,
      giftCard: giftCard,
      customer: transactionData?.customer || {},
      PaymentType: history.paymentType,
      note: transactionData?.note,
      TransactionType: transactionConstants.DRAFT,
      companyId: currentStore.companyId,
      SubTotal: transactionData?.subTotal,
      inventory: transactionData.inventory,
      currentAmountToPay: history.currentAmountToPay,
      discount: transactionData.discount || 0,
      isNoteField: transactionData.isNoteField,
      cashChangeOwed: parseToNumber(cashChangeOwed),
      isTaxApplied: transactionData.isTaxApplied,
      poiId: history?.poiId || EMPTY_STRING,
      activeCardPaymentType:
        history?.activeCardPaymentType || activeCardPaymentType,
      discountMethod: transactionData.discountMethod,
      Tax: parseToDecimalNumber(transactionData?.tax),
      creditCard: transactionData.creditCard,
      posCybersourceTransactionId:
        history?.posCybersourceTransactionId || EMPTY_STRING,
      cybersourceTransactionId:
        history?.cybersourceTransactionId || EMPTY_STRING,
      discountedValue: transactionData.discountedValue,
      isDiscountField: transactionData.isDiscountField,
      cashTenderedAmount: parseToNumber(cashTenderedAmount),
      totalAmountToPay: transactionData?.totalAmountToPay,
      paymentHistory: transactionData?.paymentHistory,
      initialTotalCogs: transactionData?.initialTotalCogs,
      initialTotalStockPrice: transactionData?.initialTotalStockPrice,
      store: {
        id: transactionData?.store?.id,
        name: transactionData?.store?.storeName || transactionData?.store?.name,
      },
      taxPercentage: transactionData?.taxPercentage || 0,
      outlet: getOutletRelationObjectForSaleTradePayload(
        currentStore,
        currentOutlet
      ),
      sessionId: getSessionIdForSaleTradePayload(
        currentStore,
        currentOutlet,
        currentSessionId
      ),
      macAddress: currentOutlet?.macAddress,
      processedBy: `${user.firstName} ${user.lastName}`,
      otherAmountTendered: parseToNumber(otherAmountTendered),
      paymentId: history?.paymentId || EMPTY_STRING, // send paymentId to identify which payment to undo in case of multiple payments of same type
    };

    let newTax = transactionData?.tax;

    //-------recalculate tax and total amount to pay (exclude gift cards from taxable base)
    if (
      dataToSend.PaymentType === transactionConstants.STORE_CREDIT &&
      dataToSend.isTaxApplied
    ) {
      // 1. Amount after discount
      const amountAfterDiscount =
        transactionData?.subTotal - (transactionData?.discount || 0);

      // 2. Gift card total (before discount)
      let giftCardTotal = transactionData.inventory?.reduce((total, item) => {
        if (item.category === PRODUCT_TYPES_ENUMS.GIFT_CARD) {
          return total + parseToNumber(item.priceAfterDiscount) * item.quantity;
        }
        return total;
      }, 0);

      // 3. Gift card total after discount (proportional share)
      let giftCardAfterDiscount = giftCardTotal;
      if (transactionData?.discount && transactionData?.subTotal > 0) {
        let discountRatio = transactionData.discount / transactionData.subTotal;
        giftCardAfterDiscount = giftCardTotal - giftCardTotal * discountRatio;
      }

      // 4. Taxable amount (exclude gift cards)
      const taxableAmount = amountAfterDiscount - giftCardAfterDiscount;

      // 5. New tax
      newTax = parseToNumber(
        (taxableAmount * transactionData?.store?.defaultTax) / 100
      );

      // 6. Update total amount
      dataToSend.totalAmountToPay = amountAfterDiscount + newTax;
    }

    newSaleTransaction(
      dataToSend,
      {
        ...transactionData,
        tax: newTax,
        taxPercentage: transactionData?.taxPercentage || 0,
      },
      handlePaymentMethod,
      handlePrintReceipt,
      currentStore?.isAutoPrintReceipt,
      true,
      toastMessages.TRANSACTION_CANCEL_SUCCESSFULLY,
      handleOpenCashDrawer,
      defaultReceiptPrinter,
      updateTransactionData
    );
  };

  const checkAmountToPay = () => {
    if (
      transactionData?.currentAmountToPay >
      convertToFixedPrecision(
        transactionData?.totalAmountToPay -
          parseToNumber(getSumOfPaymentHistory(transactionData.paymentHistory))
      )
    ) {
      customToast(toastMessages.AMOUNT_TO_PAY_LESS, toastType.ERROR);
      return true;
    }
    //  else if (transactionData?.currentAmountToPay <= 0) {
    //   customToast(toastMessages.AMOUNT_TO_PAY_GREATER, toastType.ERROR);
    //   return true;
    // }
  };

  const addTransaction = async (paymentType, poiId, creditCardData = null) => {
    if (
      checkIsOutletOpen(
        navigate,
        routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION,
        currentStore,
        getCurrentMacAddress,
        getOutletByMacAddress
      )
    ) {
      handleParkSaleClick();
      return;
    }

    activateSpinner(transactionConstants.MAKE_TRANSACTION);
    const transactionId =
      transactionData?.id || (await transactionActions.getTransactionId());
    deactivateSpinner(transactionConstants.MAKE_TRANSACTION);
    setTransactionId(transactionId);

    if (!transactionId) return;

    let currentAmountToPay = getAdjustedPaymentAmount(
      paymentType,
      transactionData,
      giftCardDetails
    );

    //------- if payment type is GIFT_CARD
    //------- then get gift card details and set update values
    //------- update charge amount according to gift card balance
    let giftCard =
      paymentType === transactionConstants.GIFT_CARD
        ? getGiftCardDetailsObject(giftCardDetails, currentAmountToPay)
        : {};

    let otherAmountTendered =
      paymentType === transactionConstants.OTHER ? currentAmountToPay : 0;
    //------- create transaction payload
    let dataToSend = buildTransactionPayload({
      user,
      transactionId,
      paymentType,
      currentAmountToPay,
      giftCard,
      transactionData: creditCardData
        ? { ...transactionData, creditCard: creditCardData }
        : transactionData,
      currentStore,
      currentOutlet,
      poiId,
      amountTendered,
      changeOwed,
      currentSessionId,
      otherAmountTendered,
    });

    const isFirstPayment =
      getSumOfPaymentHistory(dataToSend.paymentHistory) === 0;
    const newPaymentAmount =
      Number(dataToSend.SubTotal) - Number(dataToSend.discount);

    //------- if payment type is STORE_CREDIT and Pretax from settings is enabled or GIFT_CARD
    //------- then tax from payment amount will be removed
    //------- and recalculate amounts according to the balalnce or gift card amount
    if (
      paymentType === transactionConstants.STORE_CREDIT &&
      isApplyStoreCreditPaymentsAsPreTax &&
      isFirstPayment
    ) {
      dataToSend = recalculatePreTaxTotals(
        dataToSend,
        newPaymentAmount,
        isFirstPayment
      );
    }

    dataToSend.inventory = handleCalculateIndividualItemPriceStats(dataToSend);

    newSaleTransaction(
      dataToSend,
      {
        ...transactionData,
        tax: dataToSend.Tax,
        taxPercentage: dataToSend.taxPercentage,
      },
      handlePaymentMethod,
      handlePrintReceipt,
      currentStore?.isAutoPrintReceipt,
      false,
      toastMessages.TRANSACTION_ADDED_SUCCESSFULLY,
      handleOpenCashDrawer,
      defaultReceiptPrinter,
      updateTransactionData
    );
  };

  const handleAddCustomerClick = (customerToEdit = {}) => {
    setCustomerToEdit(customerToEdit);
    toggleAddCustomerModal(true);
  };

  //-------handle amount to pay change
  const handleAmountToPayChange = (value) => {
    updateTransactionData(
      { ...transactionData, currentAmountToPay: value },
      SALE_TRANSACTION_ACTIVITY_TYPES.CHANGE_AMOUNT_TO_PAY
    );
  };

  const handleCashPayment = () => {
    setAmountTendered(0);
    setChangeOwed(0);
    addTransaction(transactionConstants.CASH);
  };

  const handleOtherPayment = () => {
    addTransaction(transactionConstants.OTHER);
  };

  const handleCreditCardPayment = async (value) => {
    updateTransactionData(
      { ...transactionData, paymentDevice: value },
      SALE_TRANSACTION_ACTIVITY_TYPES.SET_VERIFONE_PAYMENT_DEVICE
    );

    addTransaction(transactionConstants.CREDIT_CARD, value);
  };

  const handleThirdPartyPayment = () => {
    addTransaction(transactionConstants.CREDIT_CARD);
  };

  const handleStoreCreditPayment = () => {
    addTransaction(transactionConstants.STORE_CREDIT);
  };

  const handleGiftCardPayment = () => {
    addTransaction(transactionConstants.GIFT_CARD);
  };

  const handlePaymentMethod = (paymentMethod) => {
    updateTransactionData(
      { ...transactionData, paymentMethod: paymentMethod },
      SALE_TRANSACTION_ACTIVITY_TYPES.UPDATE_PAYMENT_METHOD
    );
  };

  const handleTransactionCancel = async () => {
    cancelCardTransaction(
      {
        poiId: transactionData.paymentDevice,
        transactionId: transactionId,
      },
      transactionData
    );
  };

  const handlePrintReceipt = (
    transactionData,
    isOpenDrawer = false,
    giftReceipt
  ) => {
    const printData = prepareReceiptForPrinter(
      transactionData,
      user,
      transactionData.id,
      transactionData.paymentHistory,
      transactionData.store,
      transactionData.customer,
      transactionData.inventory,
      parseToDecimalNumber(transactionData.discount),
      transactionData.subTotal,
      transactionData.tax,
      transactionData.totalAmountToPay,
      transactionData.cashTenderedAmount,
      transactionData.cashChangeOwed,
      transactionData.giftCardPaymentHistory,
      isOpenDrawer,
      giftReceipt,
      transactionData.discountMethod,
      transactionData.discountedValue,
      getReceiptPrintDate(transactionData.createdOn)
    );
    printReceiptData(printData, defaultReceiptPrinter);
  };

  const handleParkSaleClick = () => {
    handleNewParkSale(transactionData, currentStore, outlet);
  };
  const selectedCustomerCheck = (selectedCustomerFlag) => {
    setSelectedCustomerFlag(selectedCustomerFlag);
  };

  const handleShowDraftModal = () => {
    // handle component unmounting
    cartItemsCount.current = 0;
  };

  useEffect(() => {
    if (!transactionData) {
      navigate(
        createCompanyDynamicUrl(
          routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION
        )
      );
    } // eslint-disable-next-line
  }, [transactionData]);

  useEffect(() => {
    if (allCustomers && allCustomers.length > 0 && selectedCustomerFlag) {
      updateTransactionData(
        {
          ...transactionData,
          customer: {
            ...allCustomers[0],
            name: allCustomers[0].firstName + " " + allCustomers[0].lastName,
          },
        },
        SALE_TRANSACTION_ACTIVITY_TYPES.UPDATE_CUSTOMER
      );
    }
    setSelectedCustomerFlag(false); // eslint-disable-next-line
  }, [allCustomers]);

  useEffect(() => {
    setAddCustomerModal(isAddCustomerModal);
  }, [isAddCustomerModal]);

  useEffect(() => {
    getStoreDevices(transactionData?.store?.id); // eslint-disable-next-line
  }, []);

  // // handle component unmounting
  // useEffect(() => {
  //   return () => {
  //     if (cartItemsCount.current > 0) {
  //       handleDraftModal(transactionConstants.TRANSACTION_DRAFT_MODAL);
  //     }
  //   }; // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    if (
      transactionData?.paymentMethod === transactionConstants.PAYMENT_COMPLETE
    ) {
      handleShowDraftModal();
    } // eslint-disable-next-line
  }, [transactionData.paymentMethod]);

  // useEffect(() => {
  //   if (state.currentStore.id !== currentStore.id) {
  //     handleShowDraftModal();
  //     updateTransactionData(
  //       transactionDefaultData,
  //       SALE_TRANSACTION_ACTIVITY_TYPES.RESET_TRANSACTION
  //     );
  //     navigate(
  //       createCompanyDynamicUrl(
  //         routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION
  //       )
  //     );
  //   } // eslint-disable-next-line
  // }, [currentStore]);

  useEffect(() => {
    if (transactionData.inventory.length <= 0) {
      handleShowDraftModal();
      navigate(
        createCompanyDynamicUrl(
          routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION
        )
      );
    } // eslint-disable-next-line
  }, [transactionData]);

  return (
    <>
      <Topbar
        title="Payment"
        backNavigation={{
          isVisible: true,
          route: routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION,
          navigationMessage:
            getSumOfPaymentHistory(transactionData.paymentHistory) > 0 &&
            transactionData.paymentMethod !==
              transactionConstants.PAYMENT_COMPLETE
              ? toastMessages.CLEAR_PARTIAL_PAYMENT
              : "",
        }}
        isNewSalePayment={true}
        totalCartItems={
          getCountOfTotalItems(transactionData?.inventory || 0, "quantity") || 0
        }
        handleParkSale={handleParkSaleClick}
        isTransactionComplete={
          transactionData?.paymentMethod ===
          transactionConstants.PAYMENT_COMPLETE
            ? true
            : false
        }
        updateTransactionData={updateTransactionData}
        showDraftModal={handleShowDraftModal}
        isParkSaleDisabled={
          transactionData?.paymentMethod ===
            transactionConstants.PAYMENT_COMPLETE ||
          isTransactionInProgress(spinnerArray)
        }
        currentStore={currentStore}
      />
      <Row className="m-0">
        <Col md={6} className="payment-cart-wrapper container-scrollbar">
          <div className="payment-cart ">
            <div className="payment-cart-item-wrapper container-scrollbar">
              {transactionData?.inventory?.map((cartItem, index) => (
                <>
                  <div
                    key={index}
                    className="d-flex justify-content-between align-items-center w-100 mt-1"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <span className="opacity-75">{cartItem.quantity} x</span>
                      <ProductNameOnPaymentScreen
                        productName={cartItem.itemName}
                      />
                      <span className="opacity-50">
                        #{getShortestSku(cartItem.sku)}
                      </span>
                    </div>
                    <span className="payment-cart-productname">
                      $
                      {parseToThousandSeperatorDecimalNumber(
                        cartItem.actualPrice
                      )}
                    </span>
                  </div>
                  {Number(cartItem?.discountPercentage) > 0 && (
                    <div
                      key={index}
                      className="d-flex justify-content-between align-items-center w-100 mt-1 mb-3"
                    >
                      <div className="d-flex align-items-center gap-2">
                        <span className="payment-cart-productname product-disocunt-label ps-5">
                          {`Discount(${
                            cartItem.isToggleDiscount
                              ? `$${cartItem.discountPercentage}`
                              : `${cartItem.discountPercentage}%`
                          })`}
                        </span>
                      </div>
                      <span className="payment-cart-productname">
                        - $
                        {parseToThousandSeperatorDecimalNumber(
                          cartItem.isToggleDiscount
                            ? parseToThousandSeperatorDecimalNumber(
                                cartItem.discountPercentage
                              )
                            : parseToThousandSeperatorDecimalNumber(
                                (Number(cartItem.actualPrice) *
                                  Number(cartItem.discountPercentage)) /
                                  100
                              )
                        )}
                      </span>
                    </div>
                  )}
                </>
              ))}
            </div>

            <div className="">
              <div className="d-flex justify-content-between align-items-center pt-3 border-top w-100 mt-4">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading">Subtotal</span>
                </div>
                <span className="payment-cart-productname">
                  $
                  {parseToThousandSeperatorDecimalNumber(
                    transactionData?.subTotal
                  )}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center w-100 mt-1">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading">
                    Discount(
                    {`${transactionData?.discountedValue}${
                      transactionData?.discountMethod ? "%" : "$"
                    }`}
                    )
                  </span>
                </div>
                <span className="payment-cart-productname">
                  $
                  {parseToThousandSeperatorDecimalNumber(
                    transactionData?.discount
                  )}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center w-100 mt-1">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading">
                    Tax({transactionData?.taxPercentage || 0}%)
                  </span>
                </div>
                <span className="payment-cart-productname">
                  ${parseToThousandSeperatorDecimalNumber(transactionData?.tax)}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center w-100 mt-2 border-top pt-2">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading d-flex justify-centent-center align-items-center gap-3">
                    SALE TOTAL{" "}
                    <span className="opacity-75">
                      {getCountOfTotalItems(
                        transactionData?.inventory || 0,
                        "quantity"
                      ) || 0}{" "}
                      Items
                    </span>
                  </span>
                </div>
                <span className="payment-cart-productname">
                  $
                  {parseToThousandSeperatorDecimalNumber(
                    transactionData?.totalAmountToPay
                  )}
                </span>
              </div>

              {transactionData?.paymentHistory?.history?.length > 0 && (
                <TransactionPaymentHistory
                  transactionData={transactionData}
                  handleReturnPayment={handleReturnPayment}
                />
              )}
            </div>
          </div>
        </Col>
        <Col md={6}>
          {transactionData?.paymentMethod ===
          transactionConstants.CASH_PAYMENT ? (
            <CashPayment
              changeOwed={changeOwed}
              spinnerArray={spinnerArray}
              amountTendered={amountTendered}
              transactionData={transactionData}
              setAmountTendered={setAmountTendered}
              handleCashPayment={handleCashPayment}
              setChangeOwed={setChangeOwed}
              setPaymentMethod={handlePaymentMethod}
              amountToPay={transactionData?.currentAmountToPay}
              handleAmountTenderedChange={handleAmountTenderedChange}
              handleFixedAmountButtonClick={handleFixedAmountButtonClick}
            />
          ) : transactionData?.paymentMethod ===
            transactionConstants.CREDIT_CARD_PAYMENT ? (
            <CardPayment
              spinnerArray={spinnerArray}
              currentStore={currentStore}
              storeDevices={storeDevices}
              transactionData={transactionData}
              setPaymentMethod={handlePaymentMethod}
              paymentDevice={transactionData.paymentDevice}
              amountToPay={transactionData?.currentAmountToPay}
              handleThirdPartyPayment={handleThirdPartyPayment}
              handleCreditCardPayment={handleCreditCardPayment}
              handleTransactionCancel={handleTransactionCancel}
            />
          ) : transactionData?.paymentMethod ===
            transactionConstants.GIFT_CARD_PAYMENT ? (
            <GiftCardPayment
              spinnerArray={spinnerArray}
              giftCardDetails={giftCardDetails}
              transactionData={transactionData}
              setPaymentMethod={handlePaymentMethod}
              amountToPay={transactionData?.currentAmountToPay}
              getGiftCardDetails={getGiftCardDetails}
              emptyGiftCardDetails={emptyGiftCardDetails}
              handleGiftCardPayment={handleGiftCardPayment}
            />
          ) : transactionData?.paymentMethod ===
            transactionConstants.OTHER_PAYMENT ? (
            <OtherPayment
              spinnerArray={spinnerArray}
              currentStore={currentStore}
              storeDevices={storeDevices}
              transactionData={transactionData}
              setPaymentMethod={handlePaymentMethod}
              paymentDevice={transactionData.paymentDevice}
              amountToPay={transactionData?.currentAmountToPay}
              handleOtherPayment={handleOtherPayment}
              handleThirdPartyPayment={handleThirdPartyPayment}
              handleCreditCardPayment={handleCreditCardPayment}
              handleTransactionCancel={handleTransactionCancel}
            />
          ) : transactionData?.paymentMethod ===
            transactionConstants.PAYMENT_COMPLETE ? (
            <PaymentComplete
              transactionData={transactionData}
              handleClick={() => {}}
              handlePrintReceipt={handlePrintReceipt}
              updateTransactionData={updateTransactionData}
              sendEmailOrSMS={sendEmailOrSMS}
              handleShowDraftModal={handleShowDraftModal}
              currentStore={currentStore}
              handleAddCustomerClick={handleAddCustomerClick}
            />
          ) : (
            <>
              <div className="payment-div-wrapper mb-3">
                <Row className="m-0 w-100">
                  <Col md={12} className="px-0">
                    <span className="amount-to-pay-heading">
                      Select a Customer
                    </span>
                  </Col>
                  {!transactionData?.customer?.id ? (
                    <Col md={12} className="mt-2 px-0">
                      <CustomerDropdown
                        isGuestCustomers={true}
                        value={selectedCustomer}
                        dropdownIndicator={false}
                        handleAddCustomerClick={handleAddCustomerClick}
                        SelectIconImage={categoryDropdownConstants.SEARCH_ICON}
                        handleChange={(selectedOption) => {
                          setSelectedCustomer(selectedOption);
                          updateTransactionData(
                            {
                              ...transactionData,
                              customer:
                                parseJsonObject(selectedOption?.value) || "",
                            },
                            SALE_TRANSACTION_ACTIVITY_TYPES.ADD_CUSTOMER
                          );
                        }}
                        selectedCustomerFlag={selectedCustomerFlag}
                      />
                    </Col>
                  ) : (
                    <Col md={12} className="mt-2 px-0">
                      <SelectedCustomerCard
                        customer={transactionData?.customer}
                        isStoreCredit={true}
                        isDeleteEditOptions={
                          !parseToNumber(
                            transactionData?.paymentHistory?.totalPaidAmount[
                              transactionConstants.STORE_CREDIT
                            ]
                          ) > 0
                        }
                        handleCustomerDeleteClick={() => {
                          setSelectedCustomer("");
                          updateTransactionData(
                            {
                              ...transactionData,
                              customer: "",
                            },
                            SALE_TRANSACTION_ACTIVITY_TYPES.DELETE_CUSTOMER
                          );
                        }}
                        handleAddCustomerClick={handleAddCustomerClick}
                        handleCustomerEditClick={handleCustomerEditClick}
                      />
                    </Col>
                  )}
                </Row>
              </div>
              <div className="payment-div-wrapper">
                <Row className="m-0 w-100">
                  <Col
                    md={12}
                    className="d-flex justify-content-between align-items-center px-0"
                  >
                    <span className="amount-to-pay-heading">
                      Charge Payment
                    </span>
                  </Col>
                  <Col
                    md={12}
                    className="d-flex justify-content-between align-items-center mt-4"
                  >
                    <span className="amount-to-pay-heading fw-normal">
                      Remaining Sale Total
                    </span>
                    <span className="amount-to-pay-heading ">
                      $
                      {parseToThousandSeperatorDecimalNumber(
                        parseToNumber(transactionData?.totalAmountToPay) -
                          parseToNumber(
                            getSumOfPaymentHistory(
                              transactionData?.paymentHistory
                            )
                          )
                      )}
                    </span>
                  </Col>
                  <Col
                    md={12}
                    className="d-flex justify-content-between align-items-center mt-4"
                  >
                    <span className="amount-to-pay-heading fw-normal">
                      Enter Amount to Charge:
                    </span>
                    <div className="amount-to-paid-field-wrapper amount-to-charge-field-wrapper">
                      <span className="dollar-icon-alignment">$</span>
                      <input
                        type="number"
                        className="amount-to-paid-field"
                        value={transactionData?.currentAmountToPay}
                        step={0.01}
                        onChange={(e) => {
                          handleAmountToPayChange(e.target.value);
                        }}
                        onBlur={(e) =>
                          handleZeroOnBlur(e, 0, (value) => {
                            handleAmountToPayChange(e.target.value);
                          })
                        }
                        max={
                          transactionData?.totalAmountToPay -
                          getSumOfPaymentHistory(
                            transactionData?.paymentHistory ||
                              transactionConstants.defaultPaymentHistory
                          )
                        }
                        min={1}
                      />
                    </div>
                  </Col>
                  <Col md={12} className="mt-4 d-flex px-0 ">
                    <Col md={4} className="px-1">
                      <Button
                        className="w-100 "
                        IconImage={CashIcon}
                        label={buttonNameConstants.CASH}
                        isDisabled={isTransactionInProgress(spinnerArray)}
                        handleClick={() => {
                          const checkAmount = checkAmountToPay();
                          if (!checkAmount) {
                            handlePaymentMethod(
                              transactionConstants.CASH_PAYMENT
                            );
                          }
                        }}
                      />
                    </Col>
                    <Col md={4} className="px-1">
                      <Button
                        className="w-100 "
                        IconImage={CreditcardIcon}
                        label={buttonNameConstants.CREDIT_CARD}
                        handleClick={() => {
                          const checkAmount = checkAmountToPay();
                          if (!checkAmount) {
                            handlePaymentMethod(
                              transactionConstants.CREDIT_CARD_PAYMENT
                            );
                          }
                        }}
                        isDisabled={
                          transactionData?.subTotal === 0 ||
                          Number(transactionData?.currentAmountToPay) === 0 ||
                          isTransactionInProgress(spinnerArray)
                        }
                      />
                    </Col>
                    <Col md={4} className="px-1">
                      <Button
                        className="w-100 "
                        IconImage={GiftCardIcon}
                        label={buttonNameConstants.GIFT_CARD_PAYMENT}
                        handleClick={() => {
                          const checkAmount = checkAmountToPay();
                          if (!checkAmount) {
                            handlePaymentMethod(
                              transactionConstants.GIFT_CARD_PAYMENT
                            );
                          }
                        }}
                        isDisabled={
                          transactionData?.subTotal === 0 ||
                          Number(transactionData?.currentAmountToPay) === 0 ||
                          isTransactionInProgress(spinnerArray) ||
                          getSumOfPaymentHistory(
                            transactionData.paymentHistory
                          ) > 0
                        }
                      />
                    </Col>
                  </Col>
                  <Col
                    md={12}
                    className="mt-4 d-flex justify-content-start px-0 "
                  >
                    <Col md={4} className="px-1">
                      <Button
                        className="w-100"
                        IconImage={StoreCreditIcon}
                        label={buttonNameConstants.STORE_CREDIT}
                        handleClick={() => {
                          const checkAmount = checkAmountToPay();
                          if (!checkAmount) {
                            handleStoreCreditPayment();
                          }
                        }}
                        isDisabled={
                          Number(transactionData?.customer.currentBalance) ===
                            0 ||
                          transactionData?.subTotal === 0 ||
                          !transactionData?.customer?.id ||
                          Number(transactionData?.currentAmountToPay) === 0 ||
                          isTransactionInProgress(spinnerArray) ||
                          //----------------- if Apply Store Credit Payments as Pre-Tax is enabled
                          //----------------- and if first payment is store credit and there is no payment made yet
                          (isApplyStoreCreditPaymentsAsPreTax &&
                            getSumOfPaymentHistory(
                              transactionData.paymentHistory
                            ) > 0)
                        }
                      />
                    </Col>
                    <Col md={4} className="px-1">
                      <Button
                        className="w-100 "
                        label={buttonNameConstants.OTHER}
                        handleClick={() => {
                          const checkAmount = checkAmountToPay();
                          if (!checkAmount) {
                            handlePaymentMethod(
                              transactionConstants.OTHER_PAYMENT
                            );
                          }
                        }}
                        isDisabled={
                          transactionData?.subTotal === 0 ||
                          Number(transactionData?.currentAmountToPay) === 0 ||
                          isTransactionInProgress(spinnerArray)
                        }
                      />
                    </Col>
                  </Col>
                </Row>
              </div>
            </>
          )}
        </Col>
      </Row>
      {addCustomerModal && (
        <AddNewCustomerModal
          selectedCustomer={selectedCustomerCheck}
          addCustomerModal={addCustomerModal}
          customerToEdit={customerToEdit}
        />
      )}
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  printer: state.printer,
  customer: state.customer,
  transaction: state.transaction,
  user: state.authentication.user,
  spinnerArray: state.system.spinnerArray,
  currentStore: state.store.currentStore,
  storeDevices: state.device.storeDevices,
  giftCardDetails: state.transaction.giftCardDetails,
  isAddCustomerModal: state.transaction.isAddCustomerModal,
  company: state.authentication.company,
  outlet: state.outlet,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setTransactionData: (data, storeId) =>
    dispatch(transactionActions.setTransactionData(data, storeId)),
  newSaleTransaction: (
    data,
    transactionObject,
    handlePaymentMethod,
    handlePrintReceipt,
    isAutoPrint,
    isUndoTransaction,
    message,
    handleCashDrawer,
    DefaultPrinter,
    updateTransactionData
  ) =>
    dispatch(
      transactionActions.newSaleTransaction(
        data,
        transactionObject,
        handlePaymentMethod,
        handlePrintReceipt,
        isAutoPrint,
        isUndoTransaction,
        message,
        handleCashDrawer,
        DefaultPrinter,
        updateTransactionData
      )
    ),
  getStoreDevices: (storeId) =>
    dispatch(deviceActions.getStoreDevices(storeId)),
  getGiftCardDetails: (storeId, barcode) =>
    dispatch(transactionActions.getGiftCardDetails(storeId, barcode)),
  emptyGiftCardDetails: () =>
    dispatch(transactionActions.emptyGiftCardDetails()),
  toggleAddCustomerModal: (value) =>
    dispatch(transactionActions.toggleAddCustomerModal(value)),
  cancelCardTransaction: (data, transactionObject) =>
    dispatch(transactionActions.cancelCardTransaction(data, transactionObject)),
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  parkSale: (data) => dispatch(transactionActions.parkSale(data)),
  handleNewParkSale: (data, currentStore, outlet, callBack) =>
    dispatch(
      transactionActions.handleNewParkSale(data, currentStore, outlet, callBack)
    ),
  sendEmailOrSMS: (data) => dispatch(transactionActions.sendEmailOrSMS(data)),
  handleDraftModal: (isToggle) =>
    dispatch({
      type: transactionConstants.SET_DRAFT_CONFIRMATION,
      data: isToggle,
    }),
  getOutletByMacAddress: (storeId, macAddress) =>
    dispatch(outletActions.getOutletByMacAddress(storeId, macAddress)),
  deactivateDraggableNotification: (data) =>
    dispatch(systemActions.deactivateDraggableNotification(data)),
});

//-------Export transaction Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewTransactionPayment);
